module.exports = __webpack_public_path__ + "img/bannerPkg.c79aaf83.png";